(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 38248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sg": function() { return /* reexport */ Column; },
  "OO": function() { return /* reexport */ ContentContainer; },
  "hU": function() { return /* reexport */ IconButton; },
  "X2": function() { return /* reexport */ Row; },
  "Sn": function() { return /* reexport */ StyledButton; },
  "rg": function() { return /* reexport */ StyledCard; },
  "Bw": function() { return /* reexport */ StyledCta; },
  "Fy": function() { return /* reexport */ StyledInput; },
  "x9": function() { return /* reexport */ StyledScreen; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(92909);
;// CONCATENATED MODULE: ./components/styles/IconButton.tsx


var IconButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "IconButton",
  componentId: "sc-1hluxaq-0"
})(["background-color:transparent;border:none;border-radius:100px;display:flex;padding:6px;cursor:pointer;width:fit-content;:hover{background-color:", ";}"], function (props) {
  return "".concat(props.theme.colors.text.primary).concat(constants/* BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX */.uR);
});
;// CONCATENATED MODULE: ./components/styles/StyledInput.tsx

var StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "StyledInput",
  componentId: "sc-bc4pvz-0"
})(["border:none;background:", ";color:", ";border-bottom:1px solid ", ";padding:12px;min-height:40px;font-size:", ";border-radius:4px;border-bottom-left-radius:0px;border-bottom-right-radius:0px;flex:1;:focus{border:none;outline:0;border-bottom:1px solid ", ";}"], function (props) {
  return props.theme.colors.container.tertiary;
}, function (props) {
  return props.theme.colors.text.primary;
}, function (props) {
  return props.theme.colors.container.tertiaryBorder;
}, function (props) {
  return props.theme.fontSize.regular;
}, function (props) {
  return props.theme.colors.text.primary;
});
;// CONCATENATED MODULE: ./components/styles/StyledCard.tsx

var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledCard",
  componentId: "sc-1fhusce-0"
})(["background-color:", ";border:1px solid ", ";border-radius:8px;padding:12px;display:flex;flex-direction:column;align-self:start;width:100%;"], function (props) {
  return props.theme.colors.container.secondary;
}, function (props) {
  return props.theme.colors.container.secondaryBorder;
});
;// CONCATENATED MODULE: ./components/styles/StyledButton.tsx


var StyledButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledButton",
  componentId: "sc-qd4wd2-0"
})(["cursor:pointer;color:", ";background-color:", ";border:none;border-radius:4px;display:flex;padding:10px 24px;width:fit-content;min-height:20px;font-size:", ";font-weight:300;user-select:none;transition:all 0.4s ease;transform:translateY(0px) scale(1);:hover{background-color:", ";}:active{transform:translateY(2px) scale(0.99);}"], function (props) {
  return props.theme.colors.text.secondary;
}, function (props) {
  return props.isDisabled ? "".concat(props.theme.colors.action.primary).concat(constants/* BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX */.uR) : props.theme.colors.action.primary;
}, function (props) {
  return props.theme.fontSize.regular;
}, function (props) {
  return props.isDisabled ? "".concat(props.theme.colors.action.primary).concat(constants/* BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX */.uR) : props.theme.colors.action.primaryHighlight;
});
;// CONCATENATED MODULE: ./components/styles/StyledScreen.tsx


var StyledScreen = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledScreen",
  componentId: "sc-fjsnv4-0"
})(["display:flex;background-color:", ";min-height:100vh;width:100vw;overflow:hidden;@media (max-width:", "){padding:env(safe-area-inset);height:100vh;min-height:-webkit-fill-available;width:-webkit-fill-available;}"], function (props) {
  return props.theme.colors.container.primary;
}, function (props) {
  return !!props.customBreakpoint ? props.customBreakpoint : constants/* MOBILE_BREAKPOINT */.Gh;
});

;// CONCATENATED MODULE: ./components/styles/ContentContainer.tsx


var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContentContainer",
  componentId: "sc-1585o7p-0"
})(["max-width:", ";padding-left:0px;padding-right:0px;padding-top:24px;margin:0px auto;flex:1;display:flex;flex-direction:column;overflow-y:auto;padding-bottom:24px;align-self:center;@media (max-width:", "){width:100%;padding-left:12px;padding-right:12px;align-self:flex-start;}"], function (props) {
  return !!props.customBreakpoint ? props.customBreakpoint : constants/* MOBILE_BREAKPOINT */.Gh;
}, function (props) {
  return !!props.customBreakpoint ? props.customBreakpoint : constants/* MOBILE_BREAKPOINT */.Gh;
});

;// CONCATENATED MODULE: ./components/styles/Row.tsx

var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Row",
  componentId: "sc-1e0z1v2-0"
})(["display:flex;flex-direction:row;"]);

;// CONCATENATED MODULE: ./components/styles/Column.tsx

var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Column",
  componentId: "sc-6gtkrx-0"
})(["display:flex;flex-direction:column;"]);

;// CONCATENATED MODULE: ./components/styles/StyledCta.tsx


var StyledCta = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "StyledCta",
  componentId: "sc-117up5g-0"
})(["color:", ";font-size:", ";font-weight:400;margin:0px;cursor:pointer;text-decoration:none;user-select:none;:hover{color:", ";text-decoration:underline;}"], function (props) {
  return "".concat(props.theme.colors.text.primary).concat(constants/* CTA_HEX_OPACITY_SUFFIX */.sK);
}, function (props) {
  return props.theme.fontSize.small;
}, function (props) {
  return props.theme.colors.text.primary;
});

;// CONCATENATED MODULE: ./components/styles/index.ts











/***/ }),

/***/ 92909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gh": function() { return /* binding */ MOBILE_BREAKPOINT; },
/* harmony export */   "cA": function() { return /* binding */ BACKGROUND_IMAGE_OPACITY; },
/* harmony export */   "k6": function() { return /* binding */ HAPE_BACKGROUND_IMAGE_URL; },
/* harmony export */   "lh": function() { return /* binding */ TYPEFORM_URL; },
/* harmony export */   "rH": function() { return /* binding */ IS_FORM_CLOSED; },
/* harmony export */   "sK": function() { return /* binding */ CTA_HEX_OPACITY_SUFFIX; },
/* harmony export */   "uR": function() { return /* binding */ BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX; },
/* harmony export */   "zZ": function() { return /* binding */ SIGNING_MESSAGE; }
/* harmony export */ });
/* unused harmony export METAMASK_URL */
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25934);

var METAMASK_URL = "https://metamask.io/";
var SIGNING_MESSAGE = ["Crypto forms is requesting your signature to allow you to login.", "We need to do this to prove you are the owner of this wallet.", "Don't worry this will not cost you any ETH", "Generated code for security: ".concat((0,uuid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)())].join("\n\n");
var BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX = "1A";
var CTA_HEX_OPACITY_SUFFIX = "A6";
var BACKGROUND_IMAGE_OPACITY = "CC";
var MOBILE_BREAKPOINT = "771px";
var HAPE_BACKGROUND_IMAGE_URL = "https://images.crypto-forms.io/holding/hapes.jpg";
var TYPEFORM_URL = "https://do3g2v3m76f.typeform.com/to/JUNLNcfn"; // export const IS_FORM_CLOSED = process.env.NEXT_PUBLIC_IS_FORM_CLOSED === "true";

var IS_FORM_CLOSED = true;

/***/ }),

/***/ 92119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _landing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27522);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var App = function App() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_landing__WEBPACK_IMPORTED_MODULE_0__["default"], {});
};

/* harmony default export */ __webpack_exports__["default"] = (App);

/***/ }),

/***/ 27522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ landing; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./components/styles/index.ts + 9 modules
var styles = __webpack_require__(38248);
;// CONCATENATED MODULE: ./assets/landing-image.svg
/* harmony default export */ var landing_image = ({"src":"/_next/static/media/landing-image.5b463035.svg","height":1200,"width":1600});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(92909);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/landing.tsx








var LANDING_PAGE_BREAKPOINT = "1296px";
var LandingScreen = (0,styled_components_browser_esm/* default */.ZP)(styles/* StyledScreen */.x9).withConfig({
  displayName: "landing__LandingScreen",
  componentId: "sc-1y5ltoy-0"
})(["background-color:", ";@media (max-width:", "){padding-top:0px;}"], function (props) {
  return props.theme.colors.container.primary;
}, LANDING_PAGE_BREAKPOINT);
var PageContentContainer = (0,styled_components_browser_esm/* default */.ZP)(styles/* ContentContainer */.OO).withConfig({
  displayName: "landing__PageContentContainer",
  componentId: "sc-1y5ltoy-1"
})(["justify-content:center;@media (max-width:", "){justify-content:flex-start;}"], LANDING_PAGE_BREAKPOINT);
var PageRow = (0,styled_components_browser_esm/* default */.ZP)(styles/* Row */.X2).withConfig({
  displayName: "landing__PageRow",
  componentId: "sc-1y5ltoy-2"
})(["justify-content:space-between;align-items:flex-start;@media (max-width:", "){flex-direction:column-reverse;align-items:center;}"], LANDING_PAGE_BREAKPOINT);
var PageColumn = (0,styled_components_browser_esm/* default */.ZP)(styles/* Column */.sg).withConfig({
  displayName: "landing__PageColumn",
  componentId: "sc-1y5ltoy-3"
})(["flex:1;margin-right:24px;@media (max-width:", "){align-items:center;margin-right:0px;}"], LANDING_PAGE_BREAKPOINT);
var Heading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "landing__Heading",
  componentId: "sc-1y5ltoy-4"
})(["color:", ";font-size:", ";font-weight:400;margin-top:24px;margin-bottom:0;@media (max-width:", "){font-size:", ";text-align:center;margin-top:37px;}"], function (props) {
  return props.theme.colors.text.primary;
}, function (props) {
  return props.theme.fontSize.title;
}, LANDING_PAGE_BREAKPOINT, function (props) {
  return props.theme.fontSize.large;
});
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "landing__Title",
  componentId: "sc-1y5ltoy-5"
})(["color:", ";font-size:", ";font-weight:400;margin-top:24px;@media (max-width:", "){font-size:", ";text-align:center;margin-top:37px;}"], function (props) {
  return props.theme.colors.text.primary;
}, function (props) {
  return props.theme.fontSize.heading;
}, LANDING_PAGE_BREAKPOINT, function (props) {
  return props.theme.fontSize.title;
});
var Body = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "landing__Body",
  componentId: "sc-1y5ltoy-6"
})(["color:", ";font-size:", ";font-weight:400;margin-bottom:36px;line-height:28px;@media (max-width:", "){font-size:", ";margin-bottom:36px;text-align:center;max-width:600px;}"], function (props) {
  return props.theme.colors.text.primary;
}, function (props) {
  return props.theme.fontSize.large;
}, LANDING_PAGE_BREAKPOINT, function (props) {
  return props.theme.fontSize.regular;
});
var ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "landing__ImageContainer",
  componentId: "sc-1y5ltoy-7"
})(["flex:1;max-width:auto;margin-top:0px;@media (max-width:", "){max-width:700px;margin-top:32px;}"], LANDING_PAGE_BREAKPOINT);

var Landing = function Landing() {
  var onContactUsClick = function onContactUsClick() {
    window.open(constants/* TYPEFORM_URL */.lh);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingScreen, {
    customBreakpoint: LANDING_PAGE_BREAKPOINT,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(styles/* ContentContainer */.OO, {
      customBreakpoint: LANDING_PAGE_BREAKPOINT,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading, {
        children: "Crypto-forms.io"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PageContentContainer, {
        customBreakpoint: LANDING_PAGE_BREAKPOINT,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PageRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PageColumn, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
              children: "Get verified insights from your Web3 community"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Body, {
              children: "Create and share forms to get the most out of your community with verified wallet submission."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* StyledButton */.Sn, {
              onClick: onContactUsClick,
              children: "Get in touch"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImageContainer, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: landing_image,
              height: 900
            })
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var landing = (Landing);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(92119);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [613,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);